<template>
  <div class="ksm-flex-1 ksm-flex-column" style="background-color:#eee">
    <div class="ksm-flex-1 ksm-flex">
      <div class="ksm-flex-00auto">
        <div class="ksm-medien__icon" v-html="$_getSvg('noten.svg')"></div>
      </div>
      <div class="ksm-ursonate_osd-wrapper">
        <DeepzoomView
          v-if="seite && isReady"
          @changePage="changeSeite"
          :modusOption="modus.option"
          :seiteIdx="parseInt(localParams.noteIdx,10)"
          :seiten="seiten"
          key="deep_noteview"
        ></DeepzoomView>
      </div>
      <div class="ksm-ursonate_note-wrapper">
        <div class="ksm-flex-1 ksm-flex-column" style="position:relative">
          <div style="position:absolute; height:100%; width:100%" class="ksm-flex-column">
            <NotenPlayer @transcriptUpdate="transcriptUpdate" :meiName="meiName" :seite="seite"></NotenPlayer>
            <div class="ksm-texte__transcript">
               <div
                 v-for="(s,j) in seite._.docInfo"
                >
                 <p v-html="s._source['98_html']" ></p>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ksm-flex-00auto ksm-flex" style="height:100px; margin-top:20px">
      <div class="ksm-texte__modus_toolbar">
        <div class="ksm-texte__merz-select">
          <select v-model="groupIdx" style="width:auto" @change="changeGroup">
            <option v-for="(g,gi) in notenGroup" :value="gi" :key="gi">{{g.label}}</option>
          </select>
        </div>
        <div class="ksm-texte__merz-select" style="margin-top:10px">
          <select v-model="localParams.noteIdx" style="width:auto">
            <option
              v-for="(s,j) in notenGroup[groupIdx].seiten"
              :value="s.idx+''"
              :key="j"
            >{{s.name}}</option>
          </select>
        </div>
      </div>
      <div class="ksm-ursonate__thumbnail--wrapper">
        <div class="ksm-ursonate__thumbnail" v-if="seiten">
          <Thumbnail
            @selectItem="changeSeite"
            :seiten="seiten"
            :seiteIdx="parseInt(localParams.noteIdx,10)"
            :aligen="'horizontal'"
            :imageHeight="75"
          ></Thumbnail>
        </div>
      </div>
      <div class="ksm-texte__modus_info">
          <div
              v-for="(s,j) in seite._.docInfo"
            >
          <!--
          Dokumenttitel: {{s._source["98_documenttitle"]}} <br/>
          Paginierung: {{s._source["98_paginierung"]}} <br/>
          -->
          Art der Seite: {{s._source["98_artderseite"]}} <br/>
          Format: {{s._source["98_format"]}} <br/>
          Datum: {{s._source["98_datumalternativ"]}} <br/>
          Standort/Eigentümer: {{s._source["98_standorteigen"]}} <br/>
          Signatur Sprengel Museum Hannover: {{s._source["98_KSAsignaturItem"]}} <br/>
          Material/Technik: {{s._source["98_materialtechnik"]}} <br/>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from "comps/Thumbnail.vue";
import DeepzoomView from "comps/DeepzoomView.vue";
import * as d3 from "d3";
import NotenPlayer from "./NotenPlayer";
import MixinUrlparams from "comps/mixins/Urlparams";

export default {
  mixins: [MixinUrlparams],
  components: { Thumbnail, DeepzoomView, NotenPlayer },
  data() {
    return {
      viewKey: "ursonate_noten",
      noteTranscriptMap: null,
      transcriptMeasureMap: null,
      // ready: false,
      meiName: null,
      localParams: {
        noteIdx: "0"
      },
      groupIdx: 0
    };
  },
  watch: {
    seite: {
      deep: true,
      handler: function(d) {
        // this.ready = false;
        this.updateMeiName(d);
      }
    }
  },
  mounted() {
    this.updateMeiName(this.seite);
  },
  computed: {
    stateUrlParams() {
      return this.modus.option.urlparams;
    },
    modus() {
      return this.$store.getters["modus/getModusByIdKey"]({
        modusId: "simple",
        viewKey: this.viewKey
      });
    },
    seite() {
      if (this.seiten) {
        return this.seiten[this.localParams.noteIdx];
      }
    },
    seiten() {
      const list = this.$store.state.ursonate_noten.merzListe;
      if (list) {
        return list[0].seiten;
      }
    },
    notenGroup() {
      if (this.seiten) {
        const group = [];
        this.seiten.forEach((s, i) => {
          const label = s.title;
          const odate = s.datum;
          let g = group.find(g => g.label === label);
          if (!g) {
            g = {
              label: label,
              seiten: [],
              idx: i,
              odate: odate
            };
            group.push(g);
          }
          g.seiten.push(s);
        });
        group.sort((a, b) => {
          if (a.odate.length == 0 && b.odate.length == 0) return 0;
          if (a.odate.length == 0) return 1;
          if (b.odate.length == 0) return -1;
          return (a.odate > b.odate ? 1 : b.odate > a.odate ? -1 : 0);
        });
        return group;
      }
    },

    isReady() {
      return this.seite && this.seite.$_parseMei;
    }
  },

  methods: {
    transcriptUpdate(d) {
      const opt = this.modus.option;
      this.$store.state.eventBus.$emit(
        ["marknote.sidebar", opt.viewKey, opt.key].join("-"),
        d
      );
    },

    updateMeiName(d) {
      //确保 $_allTranscripts 可以watch 跟踪
      // const vue = this;
      if (d && d.$_docInfo && d.$_allTranscripts) {
        // setTimeout(function() {
        // vue.ready = true;
        // }, 500);
        let arr = d.thumbnailSrc.split("/");
        arr = arr[arr.length - 1];
        arr = arr.split(".");
        arr = arr.slice(0, arr.length - 1);
        arr.push("mei");
        this.meiName = arr.join(".");
      }
    },

    changeGroup(i) {
      this.localParams.noteIdx =
        this.notenGroup[this.groupIdx].seiten[0].idx + "";
    },

    changeSeite(i) {
      this.localParams.noteIdx = i + "";
      let j = 0;
      for (const g of this.notenGroup) {
        if (g.seiten.find(s => s.idx - i === 0)) {
          this.groupIdx = j;
          return;
        }
        j++;
      }
    }
  }
};
</script>

<style lang="scss" >
.ksm-ursonate_note {
  position: absolute;
  height: 100%;
  width: 100%;
  svg {
    height: 100%;
    width: 100%;
  }
}

.ksm-ursonate__thumbnail--wrapper {
  @extend .ksm-flex-1;
  position: relative;
  padding: 0px 20px;
}
.ksm-ursonate__thumbnail {
  height: 100%;
  width: 100%;
  @extend .ksm-flex;
}

.ksm-ursonate_measure-active {
  fill: rgba(223, 126, 126, 0.336);
}

.ksm-ursonate_player {
  @extend .ksm-flex-1;
}

.ksm-ursonate_note-active {
  fill: #c00;
  stroke: "#c00";
}

.ksm-texte__modus_info {
  padding-left: 5px;
  font-size: smaller;
}
.ksm-texte__transcript {
  padding-left: 5px;
}
</style>


// WEBPACK FOOTER //
// NotenView.vue?1ebd5126